<template>
    <v-container grid-list-xl fluid>
        <v-card class="pa-2">
            <v-layout row wrap align-center>
                <v-flex xs6>
                    <content-loader
                        class="hidden-sm-and-down"
                        :height="11"
                        :width="200"
                        :speed="3"
                        primaryColor="#f1f1f1"
                        secondaryColor="#e3e3e3"
                    >
                        <rect x="0" y="0" rx="0" ry="0" :width="200" :height="11"/>
                    </content-loader>
                </v-flex>

                <v-spacer></v-spacer>

                <v-flex sm2 xs6 text-xs-right>
                    <content-loader
                        :height="68"
                        :width="297"
                        :speed="3"
                        primaryColor="#f1f1f1"
                        secondaryColor="#e3e3e3"
                    >
                        <rect x="0" y="0" rx="0" ry="0" width="297" height="68"/>
                    </content-loader>
                </v-flex>
            </v-layout>
        </v-card>

        <v-layout row wrap mt-2>
            <v-flex md2 class="hidden-sm-and-down">
                <v-card class="pa-2 mr-2">
                    <content-loader
                        :height="300"
                        :width="274"
                        :speed="3"
                        primaryColor="#f1f1f1"
                        secondaryColor="#e3e3e3"
                    >
                        <rect x="0" y="0" rx="0" ry="0" width="274" height="20"/>
                        <rect x="0" y="30" rx="0" ry="0" width="274" height="20"/>
                        <rect x="0" y="60" rx="0" ry="0" width="274" height="20"/>
                        <rect x="0" y="90" rx="0" ry="0" width="274" height="20"/>
                        <rect x="0" y="120" rx="0" ry="0" width="274" height="20"/>
                        <rect x="0" y="150" rx="0" ry="0" width="274" height="20"/>
                        <rect x="0" y="180" rx="0" ry="0" width="274" height="20"/>
                        <rect x="0" y="210" rx="0" ry="0" width="274" height="20"/>
                        <rect x="0" y="240" rx="0" ry="0" width="274" height="20"/>
                        <rect x="0" y="270" rx="0" ry="0" width="274" height="20"/>
                        <rect x="0" y="300" rx="0" ry="0" width="274" height="20"/>
                    </content-loader>
                </v-card>
            </v-flex>

            <v-flex md10 sm12>
                <v-container grid-list-md fluid pa-0>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 md3 v-for="n in [1,2,3,4]" :key="n">
                            <v-card hover>
                                <content-loader
                                    :height="504"
                                    :width="375"
                                    :speed="3"
                                    primaryColor="#f1f1f1"
                                    secondaryColor="#e3e3e3"
                                >
                                    <rect x="0" y="0" rx="0" ry="0" width="375" height="278"/>
                                    <rect x="20" y="305" rx="0" ry="0" width="335" height="20"/>
                                    <rect x="20" y="335" rx="0" ry="0" width="335" height="10"/>
                                    <rect x="20" y="355" rx="0" ry="0" width="335" height="10"/>
                                    <rect x="20" y="375" rx="0" ry="0" width="335" height="10"/>
                                    <rect x="242" y="430" rx="0" ry="0" width="93" height="30"/>
                                </content-loader>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'SearchResultsPlaceholder',
    };
</script>